import type { AmbleContent } from "..";
import { privacyInfo } from "./privacy-info";
import { amble as cyberInsuranceInfoAmble } from "./cyber-insurance-info";
import { usDefaultTermsOfPolicy } from "../shared/terms-of-policy";

/**
 * US-specific ambles for SimpleBusiness US
 */
export const simplybusinessUsAmbles: Record<string, AmbleContent> = {
  coverage_selection_welcome_privacy: privacyInfo,
  "cyber-insurance-info": cyberInsuranceInfoAmble,
  terms_of_policy: usDefaultTermsOfPolicy,
};
